var pd = require('pretty-data').pd;

export default function prettyJson(input) {
  let formatted = pd.json(input);
  return formatted
}